import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { of } from 'rxjs';

import { FeatureFlagService } from '@core/services/feature-flag.service';
import { FeatureFlag } from '@env/environment.interface';
import { Trust } from '@features/contacts/models/trust';
import { TrustService } from '@features/contacts/services/trust.service';
import {
  DialogButtonColour,
  DialogComponent
} from '@shared/components/dialog/dialog.component';
import { ModalSetting } from '@shared/components/modal/modal-setting';

@Component({
  selector: 'spark-contacts-trust-summary-panel',
  templateUrl: './trust-summary-panel.component.html',
  styleUrls: ['./trust-summary-panel.component.scss']
})
export class TrustSummaryPanelComponent {
  @Input() trustSummary!: Trust.Summary;

  modal: BsModalRef | null = null;

  constructor(
    private trustService: TrustService,
    private modalService: BsModalService,
    private featureFlagService: FeatureFlagService,
    private router: Router
  ) {}

  get contactDeletionEnabled(): boolean {
    return this.featureFlagService.isEnabled(FeatureFlag.ContactDeletion);
  }

  delete(): void {
    const initialState = {
      title: 'Delete Contact',
      message: 'This action cannot be undone.',
      buttons: [
        {
          label: 'Cancel',
          action: of([]),
          complete: () => this.closeModal(),
          colour: DialogButtonColour.default
        },
        {
          label: 'Delete',
          action: this.trustService.deleteTrust(this.trustSummary.id),
          complete: () => this.closeAndReturnToList(),
          colour: DialogButtonColour.danger
        }
      ]
    };
    this.modal = this.modalService.show(
      DialogComponent,
      ModalSetting.createDialog(initialState)
    );
  }

  closeModal() {
    this.modal?.hide();
  }

  closeAndReturnToList() {
    this.closeModal();
    this.router.navigate(['Contacts']);
  }
}
